import moment from "moment";

const Item = ({ quantity, confirmed_at, grn_line, user }) => {
  return (
    <li>
      <div>
        <p>
          {user?.full_name} - {grn_line?.product?.sku} - {quantity} szt.
        </p>
        <p>{grn_line?.grn?.from_name}</p>
        <p>
          <a
            className="link"
            target="_blank"
            href={`/grns/${grn_line?.grn?.id}`}
          >
            <strong>{grn_line?.grn?.identifier}</strong>
          </a>
        </p>
      </div>
      <span>
        <time className="text-muted">
          {moment(confirmed_at).format("DD.MM.YYYY")}
        </time>{" "}
        <time>{moment(confirmed_at).format("HH:mm")}</time>
      </span>
    </li>
  );
};

export default Item;
